"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoboLog = void 0;
var Card_1 = require("../Card");
var Tags_1 = require("../Tags");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var CardRenderer_1 = require("../render/CardRenderer");
var Size_1 = require("../render/Size");
var PhoboLog = (function (_super) {
    __extends(PhoboLog, _super);
    function PhoboLog() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.PHOBOLOG,
            tags: [Tags_1.Tags.SPACE],
            startingMegaCredits: 23,
            metadata: {
                cardNumber: 'R09',
                description: 'You start with 10 titanium and 23 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br.br;
                    b.megacredits(23).nbsp.titanium(10).digit;
                    b.corpBox('effect', function (ce) {
                        ce.effect('Your titanium resources are each worth 1 M€ extra.', function (eb) {
                            eb.titanium(1).startEffect.plus(Size_1.Size.SMALL).megacredits(1);
                        });
                    });
                }),
            },
        }) || this;
    }
    PhoboLog.prototype.play = function (player) {
        player.titanium = 10;
        player.increaseTitaniumValue();
        return undefined;
    };
    return PhoboLog;
}(Card_1.Card));
exports.PhoboLog = PhoboLog;
//# sourceMappingURL=PhoboLog.js.map